module.exports = __webpack_public_path__ + "img/starC.e7178759.svg";